import {
    CategoriesState,
    FetchCategoriesActionTypes,
    FETCH_CATEGORIES_STARTED,
    FETCH_CATEGORIES_SUCCESS,
    FETCH_CATEGORIES_ERROR,
    SET_CURRENT_CATEGORY_ID,
    SetCurrentCategoryIdActionType,
    ToggleSubCategoriesActionType,
    SET_SUB_CATEGORIES_STATUS,
    SET_MENU_CATEGORY_ID,
  } from "./types";

import { getCategory } from "./functions";

const initialState: CategoriesState = {
    items: {},
    parents: [],
    isFetching:false,
    isSubCategoriesOpen: false,
    error: {},
    currentCategoryId:0,
    menuCategoryId: 0
};

export function categoriesReducer(
    state=initialState,
    action: FetchCategoriesActionTypes | SetCurrentCategoryIdActionType | ToggleSubCategoriesActionType
):CategoriesState {

    switch(action.type){
        case FETCH_CATEGORIES_STARTED:
            return Object.assign({}, state, {
                isFetching: true
            })
        case FETCH_CATEGORIES_SUCCESS:
            return Object.assign({}, state, {
                items: action.categories,
                parents: action.parents,
                isFetching: false
            })
        case FETCH_CATEGORIES_ERROR:
            return Object.assign({}, state, {
                error: action.error,
                isFetching: false
            })
        case SET_CURRENT_CATEGORY_ID:
            return Object.assign({}, state, {
                currentCategoryId: action.currentCategoryId,
                menuCategoryId: getCategory(state.items,action.currentCategoryId) ? getCategory(state.items,action.currentCategoryId).children.length == 0 ? getCategory(state.items,action.currentCategoryId).parent : action.currentCategoryId : action.currentCategoryId
            })
        case SET_MENU_CATEGORY_ID:
            return Object.assign({}, state, {
                menuCategoryId: action.categoryId
            })
        case SET_SUB_CATEGORIES_STATUS:
            return Object.assign({}, state, {
                isSubCategoriesOpen: action.open
            })
        default:
            return state;
    }
} 